import { FC, ReactElement } from 'react'

import { Button } from '@/components'
import { SubmitButton } from '@/compositions/@buttons/SubmitButton/SubmitButton'
import { trans } from '@/helpers/trans'

import './FormActionButtons.scss'

interface FormActionButtonsProps {
    isLoading?: boolean
    disabled?: boolean
    hideSubmit?: boolean
    cancelText?: string
    submitText?: string
    onCancelClick: () => void
    className?: string
    cancelButtonClassName?: string
    submitButtonClassName?: string
}

export const FormActionButtons: FC<FormActionButtonsProps> = ({
    isLoading,
    disabled,
    hideSubmit = false,
    cancelText = trans('compositions.modalContent.cancel'),
    submitText = trans('compositions.modalContent.save'),
    onCancelClick,
    className = '',
    cancelButtonClassName = '',
    submitButtonClassName = '',
}): ReactElement => (
    <div className={`form-action-buttons ${className}`}>
        <Button
            text={cancelText}
            onClick={onCancelClick}
            className={`form-action-buttons__cancel ${cancelButtonClassName}`}
        />
        {! hideSubmit && (
            <SubmitButton
                isLoading={isLoading}
                disabled={disabled}
                type="submit"
                text={submitText}
                className={`form-action-buttons__confirm ${submitButtonClassName}`}
            />
        )}
    </div>
)
